var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "page question-app" },
    [
      _c("ncc-question-header"),
      _vm._v(" "),
      _c("ncc-question-option-bar"),
      _vm._v(" "),
      _c("ncc-question-toolbar"),
      _vm._v(" "),
      _c("ncc-question-video-bar"),
      _vm._v(" "),
      _c("ncc-question-prayer-bar"),
      _vm._v(" "),
      _c("ncc-question-comment-bar")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }